import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Meta } from "@angular/platform-browser";
import { NavigationExtras, Router } from "@angular/router";
import { SettingsService } from "../settings/settings.service";
import { register } from 'swiper/element/bundle';
import { InfoModalOnboarding } from "./info-modal/info-modal";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AgendarOnboarding } from "./agendar/agendar";
import { UrlService } from "../services/url.service";
import { PutStepService } from "../services/put_step.service";
import { PostHogService } from "../services/posthog.register.service";
import { OnboardingLabelService } from "../services/onboardingStepLabels.service";
register();

declare var $: any;

@Component({
    selector: 'app-onboarding',
    templateUrl: './onboarding.html',
    styleUrls: ['./onboarding.less'],
    standalone: false
})
export class OnBoardingComponent implements OnInit {


  valForm: FormGroup;
  valFormFacturador:FormGroup;

  business_name:any=localStorage.getItem('business_name');
  user_name:any=localStorage.getItem('full_name');

  constructor(
    private _formBuilder: FormBuilder,
    public settings: SettingsService,
    public dialog: MatDialog,
    public route:Router,
    private urlService: UrlService,
    private router:Router,
    private putStepService: PutStepService,
    private posthog: PostHogService,
    private onboardingLabel: OnboardingLabelService,
    private change:ChangeDetectorRef
    ) {

    this.valForm = this._formBuilder.group({
      'clave_sii': ['',  Validators.compose([Validators.required])],
    });

    this.valFormFacturador = this._formBuilder.group({
      'facturador': ['',  Validators.compose([Validators.required])],
      'otro': [''],
    });

    const urlOriginal = this.router.url
    this.urlService.setOriginalUrl(urlOriginal);

  }

  hide: boolean = true;
  step:any=null;
  id_company=localStorage.getItem('company_id');
  ngOnInit() {

    this.get_personal_data();
    this.get_facturadores();
    this.get_ejecutivo_dinamico();

    this.get_step();


  }

  async get_personal_data() {
    try {
      const bd: any = await this.settings.get_query(1, 'current-user/');
      var body_data: any = bd._body;
      switch (bd.status) {
        case 200:


          this.user_name =body_data.user.first_name;

          break;
        default:

          break;
      }
    } catch (bd: any) {



    }
  }


  open_modal_info(step:any) {
    let dialogRef = this.dialog.open(InfoModalOnboarding, {
      width: '700px',
      autoFocus: false,
    });

    dialogRef.componentInstance.step = step;
    dialogRef.componentInstance.contacto = this.contacto;

    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      if(result == true){
        this.step = 1;
        this.putStepService.put_step(1, this.id_company);
      }
      if(result == 'retry'){
        this.valForm.controls['clave_sii'].reset();
      }

      if(result == 'six'){
        this.step = 6;
        this.putStepService.put_step(6, this.id_company);
      }

    });

  }

  open_modal_info_disable(step:any) {
    let dialogRef = this.dialog.open(InfoModalOnboarding, {
      width: '700px',
      autoFocus: false,
      disableClose: false
    });

    dialogRef.componentInstance.step = step;
    dialogRef.componentInstance.contacto = this.contacto;

    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      if(result == true){
        this.step = 2;
        this.posthog.capture(
          'onboarding',
          null,
          null,
          'Seleccionar facturador',
          'web',
          2
        );
      }
      if(result == 'retry'){
        this.valForm.controls['clave_sii'].reset();
      }

    });

  }

  agendar() {
    let dialogRef = this.dialog.open(AgendarOnboarding, {
      width: '700px',
      minHeight: '600px',
      autoFocus: false,
    });



  }


  navegar_a(url:string){
    window.open(url, "_blank")
  }


  loading:boolean=false;
  pasar_al_paso_2(){
    this.loading = true;

    this.guardar_clave_sii();

  }

  facturador_seleccionado:any=null;
  selecionar_facturador($event:any){
    const value = Number($event.value);
    this.facturador_seleccionado = value;
  }

  disable_btn:boolean=true;
  validate_key($event:any){
    if($event.target.value != undefined && $event.target.value != null && $event.target.value != ""){
      this.disable_btn = false;
    }else{
      this.disable_btn = true;
    }
  }

  loading_sii:boolean=false;
  success_sii:boolean=false;
  async verificar_guardar_clave_sii(validate?:any){
    try {


      let value:any = {"sii_key": this.valForm.controls['clave_sii'].value}
      if (validate) {
        value["validate"] = true;
      }

      this.loading_sii = true;
      this.disable_btn = true;
      this.success_sii = false;


      const bd: any = await this.settings.get_query(3, `cliente/validate-clave-sii/${this.id_company}/`,value );
      var body_data: any =bd._body;
      switch (bd.status) {
        case 200:


          this.disable_btn = false;
          this.loading_sii = false;
          this.success_sii = true;

          this.pasar_al_paso_2();

        break;
        default:

        break;
      }

    } catch (bd:any) {

      this.valForm.controls['clave_sii'].setErrors({'incorrect': true});
      this.disable_btn = false;
      this.loading_sii = false;
      this.success_sii = false;

      switch (bd.status) {
        case 400:
          let error = "Acceso bloqueado. Intente nuevamente más tarde."
          if(bd.error.error.errors.non_field_errors[0] == error){
            this.open_modal_info_disable(9);
            this.valForm.disable();
          }else{
            this.open_modal_info(8);
          }

      }

    }
  }

  async guardar_clave_sii(){

    try {


      let value:any = {"sii_key": this.valForm.controls['clave_sii'].value}
       value["validate"] = false;


      const bd: any = await this.settings.get_query(3, `cliente/validate-clave-sii/${this.id_company}/`,value );
      var body_data: any =bd._body;
      switch (bd.status) {
        case 200:

        console.log("POST CLAVE", body_data);

        let facturador_id = body_data.success.info.facturador_id;
          if(facturador_id ==  1){
            this.robots_riesgo()
          }else{
            this.putStepService.put_step(2, this.id_company);
            this.step = 2;

            this.loading = false;
          }

        break;
        default:

        break;
      }

    } catch (bd:any) {



    }
  }

  facturadores:any[]=[];
  async get_facturadores(){
    try {



      const bd: any = await this.settings.get_query(1, `cliente/facturador-electronico/`, );
      var body_data: any =bd._body;
      switch (bd.status) {
        case 200:


        this.facturadores = body_data.success.info;
        console.log(this.facturadores)


        break;
        default:

        break;
      }

    } catch (bd:any) {


    }
  }

  name_facturador_otro:string="";
  disabled_facturador:boolean=false;
  async put_facturador(){
    try {
      this.disabled_facturador = true;
      this.loading = true;
      let value: any = { 'facturador_id': this.facturador_seleccionado };

      if (this.facturador_seleccionado == 7) {
        value['facturador_otro'] = this.valFormFacturador.controls['otro'].value;
      }

      const bd: any = await this.settings.get_query(3, `cliente/facturador-electronico-individual/${this.id_company}/`, value);
      const body_data: any = bd._body;


      switch (bd.status) {
        case 200:
          this.robots_riesgo();
          break;
      }

    } catch (bd: any) {

      this.disabled_facturador = false;
      this.loading = false;

    }
  }

  id_simulation:any;
  async robots_riesgo(){
    try {
      const bd: any = await this.settings.get_query(3, `/tubo/mirai-e/${this.id_company}/`, {});
      const body_data: any = bd._body;

      switch (bd.status) {
        case 200:

          this.id_simulation = body_data.success.data.simulation_id;

          if(this.id_simulation){
            this.step = 4;

            this.posthog.capture(
              'onboarding',
              null,
              null,
              'Mirai aprueba y el cliente tiene una simulación disponible',
              'web',
              4
            );

            this.disabled_facturador = false;
            this.loading = false;
          }else{
            //cuando mirai aprueba pero no crea la sim
            this.step = 6;
            this.substep = 10;

            this.posthog.capture(
              'onboarding',
              null,
              null,
              'Mirai aprobó, pero no se logró crear la simulación',
              'web',
              13
            );
          }
          break;
      }
    } catch (bd: any) {
      this.putStepService.put_step(5, this.id_company);
      this.step = 5;


      this.disabled_facturador = false;
      this.loading = false;
    }
  }

  omitir(){
    this.route.navigate(['/home']);
  }



  ir_al_paso($event:any) {
    let value = Number($event.target.value);
    let previousStep = this.step;
    let previousSubstep = this.substep;


    const validSteps = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 133];

    if (!validSteps.includes(value)) {
      this.step = null;
      return;
    }

    if (value >= 6) {
      this.setSimulationStep(value);
      this.putStepService.put_step(value, this.id_company);

      if (previousStep === this.step && previousSubstep === this.substep) {
        this.step = null;
        setTimeout(() => {
          this.step = 6;
        }, 0);
      }
    } else {
      this.step = value;
      this.putStepService.put_step(value, this.id_company);
    }
  }


  substep:any=1;
  formstep: number = 1;
  signstep: number = 0;
  documentacionStep: number = 1;
  revisionStep: number = 1;
  esEmpresaEnUnDia: boolean = false;
  simulacion: number = 0;

  step13Visited: boolean = false;

  setSimulationStep(simulationStep: number) {
    this.step = 6;

    if (simulationStep === 6) {
      // Simulación
      this.substep = 1;
      this.formstep = 1;
      this.signstep = 0;
    } else if (simulationStep === 7) {
      // Carga documentos
      this.substep = 8;
      this.documentacionStep = 1;
    } else if (simulationStep === 8) {
      // Pantalla espera - carga documentos
      this.substep = 8;
      this.documentacionStep = 4;
    } else if (simulationStep === 9) {
      // Revision contrato
      this.substep = 9;
      this.revisionStep = 1;
    } else if (simulationStep === 10) {
      // Pantalla espera - revision
      this.substep = 9;
      this.revisionStep = 2;
    } else if (simulationStep === 13) {
    // Crear simulacion
    if (this.step13Visited) {
      window.location.reload();
      return;
    } else {
      this.substep = 10;
      this.simulacion = 0;
      this.step13Visited = true;
    }
  } else if (simulationStep === 133) {

      this.substep = 4;
      this.formstep = 3;
      this.signstep = 0;
    } else if (simulationStep === 14) {
      // Firma - PIN
      this.substep = 4;
      this.formstep = 3;
      this.signstep = 4;
    }else if (simulationStep === 15) {
      // Firma documentacion
      this.substep = 4;
      this.formstep = 3;
      this.signstep = 5;
    } else if (simulationStep === 16) {
      // Retomar operacion
      this.substep = 6;
      this.formstep = 0;
      this.signstep = 0;
    }
  }

  //endpoint contacto dinamico
  contacto:any="Cargando"
  async get_ejecutivo_dinamico(){
    try {
      const bd: any = await this.settings.get_query(1, `/cliente/ejecutivo-representante-empresa/`+this.id_company+'/' );
      var body_data: any =bd._body;
      switch (bd.status) {
        case 200:
          this.contacto = body_data.success.info.numero_telefono;
        break;

        default:
        break;
      }
    } catch (bd:any) {
    }
  }

  navigateToHome() {
    this.route.navigate(['home/']);
  }

  //JP
  loading_step:boolean=false;
  async get_step(){
    try {
      this.loading_step = true;

      const bd: any = await this.settings.get_query(1, `cliente/obtener-paso-company/${this.id_company}/`, );
      var body_data: any = bd._body;

      const stepBackend = body_data.success.step;
      if(body_data.success.simulation_id != 0){
        this.id_simulation = body_data.success.simulation_id;
      }

      if (stepBackend >= 6) {
        this.setSimulationStep(stepBackend);
      } else {
        this.step = stepBackend;
      }

      const label = this.onboardingLabel.getLabel(stepBackend);

      this.posthog.capture(
        'onboarding',
        null,
        null,
        label,
        'web',
        stepBackend
      );

      this.loading_step = false;



    } catch (bd:any) {
      console.log("ERROR", bd)
      this.loading_step = false;
      console.error('Error al obtener el paso del backend');
    }
  }

  @HostListener('window:companyIdChanged', ['$event'])
  onCompanyIdChanged(event: CustomEvent) {
    console.log('Company ID changed:', event.detail);
    this.ngOnInit();
  }


}
